module.exports = __webpack_public_path__ + "img/broadcast-chat-img.186744dd.jpg";